module.exports = __webpack_public_path__ + "static/media/login_image_2.9e31f377.jpg";